import { useEffect, useRef } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustBand from "@/components/TrustBand";
import WorksheetPreview from "@/components/WorksheetPreview";
import Philosophy from "@/components/Philosophy";
import HowItWorks from "@/components/HowItWorks";
import Benefits from "@/components/Benefits";
import ThreeQuestions from "@/components/ThreeQuestions";
import AboutCreator from "@/components/AboutCreator";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  const observerRef = useRef(null);

  useEffect(() => {
    // Per-page SEO
    document.title = "Reawaken Your Creativity · Awakened Artist Academy";
    const desc = "A quiet doorway back to your creativity. Free 5-minute Creative Reset guide for artists, writers, and makers who have been listening less.";
    const setMeta = (sel, attr, val) => {
      const el = document.head.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };
    setMeta('meta[name="description"]', 'content', desc);
    setMeta('meta[property="og:title"]', 'content', 'Reawaken Your Creativity · Awakened Artist Academy');
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[name="twitter:description"]', 'content', desc);

    const els = document.querySelectorAll("[data-reveal]");
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-up");
            observerRef.current.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observerRef.current.observe(el));
    return () => observerRef.current && observerRef.current.disconnect();
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-paper text-[#1A1A1A]">
      <Navbar />
      <main>
        <Hero />
        <TrustBand />
        <WorksheetPreview />
        <Philosophy />
        <HowItWorks />
        <Benefits />
        <ThreeQuestions />
        <AboutCreator />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
